import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import { LEFT, RIGHT } from "../constants";
import { MISSING_ADJUSTABLE_PART, MISSING_OCCUPIED_HOLES, NO_PRODUCT_REF, } from "../constants/errors";
export const removeAlignmentConnectionsComponentFrom = (entities) => {
    entities.forEach((entity) => {
        entity.removeComponent(ComponentIds.ALIGNMENT_CONNECTIONS_COMPONENT_ID);
    });
};
export const getEntityProductRef = (entity) => {
    var _a;
    const productRef = (_a = entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.productRef;
    if (!productRef) {
        throw new Error(NO_PRODUCT_REF);
    }
    return productRef;
};
export const hasRemovedSideUnit = (entity, side) => {
    if (side === LEFT) {
        return entity.hasComponent(COMPONENT_IDS.REMOVE_LEFT_SIDE_UNIT_ID);
    }
    if (side === RIGHT) {
        return entity.hasComponent(COMPONENT_IDS.REMOVE_RIGHT_SIDE_UNIT_ID);
    }
    return false;
};
/**
 * Get how many holes an entity covers.
 * This value is normally a negative number, but before returning it the number is converted to a positive
 * @param entity
 * @returns
 */
export const getEntityHolesOccupied = (entity) => {
    var _a;
    const entityHolesOccupied = (_a = entity.getComponent(COMPONENT_IDS.INSERT)) === null || _a === void 0 ? void 0 : _a.holesOccupied;
    if (!entityHolesOccupied)
        throw new Error(MISSING_OCCUPIED_HOLES);
    return Math.abs(entityHolesOccupied);
};
export const isAdjustableEntity = (entity) => entity.hasComponent(COMPONENT_IDS.ADJUSTABLE_COMPONENT);
export const isAdjustableEntityChild = (entity) => entity.hasComponent(COMPONENT_IDS.ADJUSTABLE_STATE_COMPONENT);
export const getAdjustableShelfAssemblyPart = (entity, partKey) => {
    const assemblyPartEntity = HierarchyUtils.getAssemblyEntities(entity).find((e) => {
        var _a;
        return ((_a = e.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.partKey) === partKey;
    });
    if (!assemblyPartEntity)
        throw new Error(MISSING_ADJUSTABLE_PART);
    return assemblyPartEntity;
};
